export function chatErrorCopy(message, t) {
  if (!message) return '';
  if (message.startsWith('travel.chat.')) return t(message);
  if (/登入已過期/.test(message)) return t('travel.chat.authExpired');
  if (message === '聊天室目前為唯讀，無法回應訊息。') return t('travel.chat.reactionReadonly');
  if (message === '目前無法編輯這則訊息。') return t('travel.chat.editDenied');
  if (message === '目前無法撤回這則訊息。') return t('travel.chat.revokeDenied');
  if (/唯讀/.test(message)) return t('travel.chat.readonly');
  if (/目前暫時無法建立/.test(message)) return t('travel.chat.chatDisabled');
  if (/僅支援 JPG/.test(message)) return t('travel.chat.imageUnsupported');
  return t('travel.chat.failed');
}
